import { Toolbar, Typography, Box } from '@mui/material'
import { Separator } from './Separator'
import { SwitchAppButton } from './SwitchAppButton'
import { HeaderProps } from './Header.types'
import { StyledAppBar, TitleText, Pointer } from './Header.styles'

export const Header = ({
  brandLogo,
  brandLogoStyles,
  titleText,
  profileText,
  handleBrandLogoClick,
  tenantName,
  switchIcon,
  handleTenantSwitchClick,
  logoOne,
  logoTwo,
  handleLogoOneClick,
  handleLogoTwoClick,
  isClickable,
  leftElement,
}: HeaderProps) => {
  return (
    <StyledAppBar position="static">
      <Toolbar>
        <Box display="flex" flexGrow={1} alignItems="center">
          <Pointer
            onClick={handleBrandLogoClick}
            role="button"
            aria-label="logo"
          >
            <img src={brandLogo} alt="Logo" style={brandLogoStyles} />
          </Pointer>
          {titleText && (
            <>
              <Separator height="44px" />
              <TitleText>{titleText}</TitleText>
            </>
          )}
          {leftElement && (
            <>
              <Separator height="44px" />
              {leftElement}
            </>
          )}
        </Box>

        <Typography variant="h4">{profileText}</Typography>
        <Separator height="33px" />

        <Box
          component="div"
          sx={{ cursor: isClickable ? 'pointer' : 'default' }}
          onClick={
            isClickable && handleTenantSwitchClick
              ? handleTenantSwitchClick
              : undefined
          }
          role="button"
          aria-label="switch tenant"
        >
          <Box display="flex">
            {isClickable && (
              <Box display="flex" alignItems="center" mr={1}>
                {switchIcon}
              </Box>
            )}
            <Typography variant="body1">{tenantName}</Typography>
          </Box>
        </Box>

        {logoOne && logoTwo && handleLogoOneClick && handleLogoTwoClick && (
          <>
            <Separator height="33px" />
            <SwitchAppButton
              logoOne={logoOne}
              logoTwo={logoTwo}
              handleLogoOneClick={handleLogoOneClick}
              handleLogoTwoClick={handleLogoTwoClick}
            />
          </>
        )}
      </Toolbar>
    </StyledAppBar>
  )
}
